import { lang } from '@lib/constants'

export default function ComeBackSoon() {
	return (
		<section className="section text-center">
			<div className="container center text-xl mt-[3rem] mb-[3rem]">
				<p className="mb-5">
					{lang === 'es-es'
						? `Ahora mismo nuestra tienda no está funcionando.`
						: `The Shop is currently unavailable. We expect to re-launch and open up checkout in June! For now, feel free to leave items in your cart for later.

						Thank you!`}
				</p>
				<p>{lang === 'es-es' ? `¡Muchas gracias!` : `Thank you!`}</p>
			</div>
		</section>
	)
}

export const getServerSideProps = async () =>
	lang === 'en-us' || lang === 'en-gb' || lang === 'es-es'
		? { props: {} }
		: {
				notFound: true
		  }
